import React from 'react';
import { Card } from '../ui/card';

const PriceDisplay = ({ priceData, loadingPrice, language }) => {
  if (loadingPrice) {
    return (
      <div className="text-center py-4">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
        <p className="text-sm text-gray-600 mt-2">
          {language === 'en' ? 'Calculating price...' : 'Calcolo in corso...'}
        </p>
      </div>
    );
  }

  if (!priceData) return null;

  return (
    <Card className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-300 p-6">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-gray-700">
              {language === 'en' ? 'Distance' : 'Distanza'}
            </p>
            <p className="text-2xl font-bold text-gray-900">{priceData.distance_km} km</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-semibold text-gray-700">
              {language === 'en' ? 'Estimated Price' : 'Prezzo Stimato'}
            </p>
            <p className="text-4xl font-bold text-amber-600">€{priceData.final_price}</p>
          </div>
        </div>

        {/* Price breakdown */}
        <div className="border-t border-amber-200 pt-3 space-y-1 text-sm">
          <div className="flex justify-between text-gray-600">
            <span>{language === 'en' ? 'Base + Distance' : 'Base + Distanza'}:</span>
            <span className="font-semibold">€{Math.round(priceData.base_price)}</span>
          </div>
          {priceData.multiplier_applied && (
            <div className="flex justify-between text-blue-600">
              <span>
                {priceData.multiplier_applied === 'airport' && (language === 'en' ? '✈️ Airport' : '✈️ Aeroporto')}
                {priceData.multiplier_applied === 'mountain' && (language === 'en' ? '🏔️ Mountain' : '🏔️ Montagna')}
                {priceData.multiplier_applied === 'city' && (language === 'en' ? '🏙️ City' : '🏙️ City')}
              </span>
              <span className="font-semibold">{language === 'en' ? 'Applied' : 'Applicato'}</span>
            </div>
          )}
          {priceData.night_rate && (
            <div className="flex justify-between text-purple-600">
              <span>🌙 {language === 'en' ? 'Night rate (22:00-06:00)' : 'Tariffa notturna (22:00-06:00)'}</span>
              <span className="font-semibold">{language === 'en' ? 'Applied' : 'Applicata'}</span>
            </div>
          )}
        </div>

        <p className="text-xs text-gray-500 text-center border-t border-amber-200 pt-2">
          {language === 'en' ? 'Final price may vary based on route conditions' : 'Il prezzo finale può variare in base alle condizioni del percorso'}
        </p>
      </div>
    </Card>
  );
};

export default PriceDisplay;
